import { EMPTY_OBJECT } from '../../../../constants/common'
import { LOCAL_STORAGE_GRETA_AI_CHAT_PANEL_KEY } from '../../../../constants/storage'
import { isValueObjectType } from '../../../../utils/common'
import {
  getStorageSerializedItem,
  setStorageSerializedItem,
} from '../../../../utils/storage'
import { GretaAIChatMode } from '../../GretaAIChat.constants'
import { getIsGretaAIChatExpanded } from '../../GretaAIChat.utils'

export function getToggledGretaAIChatMode(mode) {
  return getIsGretaAIChatExpanded(mode)
    ? GretaAIChatMode.Compact
    : GretaAIChatMode.Expanded
}

export function readGretaAIChatPanelPrefs(userId) {
  const prefs = getStorageSerializedItem(
    LOCAL_STORAGE_GRETA_AI_CHAT_PANEL_KEY
  )?.[userId]

  return isValueObjectType(prefs) ? prefs : EMPTY_OBJECT
}

export function writeGretaAIChatPanelPref(userId, key, value) {
  const store = getStorageSerializedItem(LOCAL_STORAGE_GRETA_AI_CHAT_PANEL_KEY)

  setStorageSerializedItem(LOCAL_STORAGE_GRETA_AI_CHAT_PANEL_KEY, {
    ...(isValueObjectType(store) ? store : null),
    [userId]: { ...readGretaAIChatPanelPrefs(userId), [key]: value },
  })
}
